module.exports = __webpack_public_path__ + "img/easy8_logo_yellow.4fd1de37.svg";